<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="tableOptions"
    :server-items-length="totalItems"
    :headers="headers"
    :items="groupHeadfees"
    :footer-props="footerTable"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    :items-per-page="5"
  >
    <template v-if="propHeaders && propHeaders.length" v-slot:top="{ pagination }">
      <v-data-footer
        :pagination="pagination"
        :options.sync="tableOptions"
        :items-per-page-options="[5, 10, 15]"
        items-per-page-text="Số khoản phí mỗi trang"
        :page-text="pageText"
      />
    </template>
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">Hiện tại chưa có {{getText(group.type)}} trong danh sách.</div>
    </template>
    <template v-slot:[`item.title`]="{ item }">
      <router-link :to="{ path: `/head-fees/${item.head_fee.id}` }" class="text-decoration-none">{{ item.head_fee ? item.head_fee.title : '' }}</router-link>
    </template>
    <template v-slot:[`item.type`]="{ item }">
      {{ item.head_fee ? item.head_fee.head_fee_apply.title : '' }}
    </template>
    <template v-slot:[`item.category`]="{ item }">
      <span v-if="item.head_fee">{{ item.head_fee.category == 'custom' ? 'Bổ sung' : 'Mặc định' }}</span>
    </template>
    <template v-slot:[`item.note`]="{ item }">
      <v-tooltip max-width="250px" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="text-truncate" style="max-width: 250px;">{{ item.head_fee ? item.head_fee.note : '' }}</div>
        </template>
        <span class="tooltip white--text">{{ item.head_fee ? item.head_fee.note : '' }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
const originHeaders = [
  {
    text: 'Khoản phí thu/đóng',
    value: 'title',
    align: 'left',
    sortable: false,
    show: true,
    width: '50%'
  },
  {
    text: 'Phân loại',
    value: 'category',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Ghi chú',
    value: 'note',
    align: 'left',
    sortable: false,
    show: true,
    width: '30%'
  }
]
const originHeadersDeduction = [
  {
    text: 'Khoản giảm trừ',
    value: 'title',
    align: 'left',
    sortable: false,
    show: true,
    width: '30%',
  },
  {
    text: 'Áp dụng với khoản phí thu/đóng',
    value: 'type',
    align: 'left',
    sortable: false,
    show: true,
    width: '30%',
  },
  {
    text: 'Phân loại',
    value: 'category',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%',
  },
  {
    text: 'Ghi chú',
    value: 'note',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%',
  },
]

export default {
  data() {
    return {
      headers: null,
      tableOptions: {},
      selected: [],
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ]
    }
  },
  props: {
    propHeaders: {
      type: Array,
      default: () => []
    },
    filter: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('tuitionFeeGroupHeadFee', [
      'totalItems',
      'pageText',
      'groupHeadfees',
      'loading',
      'groupHeadfeesSearchParams'
    ]),
    ...mapGetters({
      group: 'tuitionFeeGroup/groupInfo'
    }),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số khoản phí mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('tuitionFeeGroupHeadFee', ['requestPageSettings']),
    getHeader(type) {
      switch (type) {
        case 'normal': {
          this.headers = originHeaders
          break
        }
        case 'priority': {
          this.headers = originHeadersDeduction
          break
        }
      }
    },
    getText(type) {
      switch (type) {
        case 'normal': {
          return 'khoản phí'
        }
        case 'priority': {
          return 'khoản giảm trừ'
        }
      }
    },
  },
  async created() {
    this.getHeader(this.group.type)
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
            id: this.$route.params.id
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: max-content;
  max-width: 100%;
}
.tooltip {
  word-wrap: break-word;
}
</style>
